// A table heading you can click to sort. See src/lib/tableSort.ts for the
// comparison rules; this file is only the control.
//
// It is a real <button> inside the <th>, not an onClick on the <th> itself:
// a heading that reacts to a click but cannot be reached by Tab or fired with
// Enter is a control only a mouse user has. `aria-sort` on the th is what a
// screen reader announces.
import type { JSX } from 'preact';
import type { SortState } from '../lib/tableSort';
import { ariaSort } from '../lib/tableSort';

export function SortableTh({
  label, sortKey, state, onSort, className, testId,
}: {
  label: JSX.Element | string;
  /** The key into the table's accessor map. */
  sortKey: string;
  state: SortState;
  onSort: (key: string) => void;
  className?: string;
  testId?: string;
}): JSX.Element {
  const active = state.key === sortKey;
  const arrow = !active ? '' : state.direction === 'asc' ? ' ▲' : ' ▼';
  return (
    <th class={className} aria-sort={ariaSort(state, sortKey)} data-testid={testId}>
      <button
        type="button"
        class="th-sort"
        onClick={() => onSort(sortKey)}
        // The heading text alone would read as "Employee, button" with no clue
        // what pressing it does, so the action is spelled out for a reader.
        aria-label={`Sort by ${typeof label === 'string' ? label : sortKey}`}
      >
        {label}
        <span aria-hidden="true">{arrow}</span>
      </button>
    </th>
  );
}
